import React from "react";
import styled from "styled-components";
import { IStyleableProps } from "../../commonTypes";
import { ErrorWrapper } from "../styled";

interface IFormErrorProps {
  error: string | undefined;
  touched: boolean | undefined;
  width?: string;
}

interface IWrapperProps {
  width?: string;
}

const Wrapper = styled.div<IWrapperProps>`
  width: ${(props) => (props.width ? props.width : null)};
`;

const FormError = ({
  error,
  touched,
  width,
  ...props
}: IFormErrorProps & IStyleableProps) => {
  return error && touched ? (
    <Wrapper width={width} {...props}>
      <ErrorWrapper>{error}</ErrorWrapper>
    </Wrapper>
  ) : null;
};

export default FormError;
